module.exports = __webpack_public_path__ + "img/avatar.e7d489e3.jpg";